import { useRef } from "react";
import SplitLayout from "../../../components/atoms/SplitLayout";
import DirectMessageForm from "../../../components/features/DirectMessageForm";
import { StudentMessageHeader } from "../../../components/features/StudentMessageHeader";
import { StudentMessageList } from "../../../components/features/StudentMessageList";
import MessageThreadInterface from "../../../interfaces/MessageThreadInterface";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import OperatorProfileInterface from "../../../interfaces/OperatorProfileInterface";
import styles from "./styles.scss";

interface Props {
  sectionId: string;
  messageThread: MessageThreadInterface | null;
  onCloseRightColumn: () => void;
  operator: OperatorInterface;
  operatorProfile: OperatorProfileInterface | null;
}

const SectionStudentMessage = (props: Props) => {
  const splitLayoutRef = useRef<HTMLDivElement>(null);
  if (!props.messageThread || !props.operatorProfile) {
    return null;
  }

  return (
    <div className={styles.root} ref={splitLayoutRef}>
      <SplitLayout.Header>
        <StudentMessageHeader
          student={props.messageThread.student}
          isFollowing={!!props.messageThread.isFollowing}
          onClose={props.onCloseRightColumn}
          showCloseIcon={true}
        />
      </SplitLayout.Header>
      <SplitLayout.Body>
        <StudentMessageList
          sectionId={props.sectionId}
          student={props.messageThread.student}
        />
        <DirectMessageForm
          sectionId={props.sectionId}
          student={props.messageThread.student}
          operator={props.operator}
          operatorProfile={props.operatorProfile}
          textareaMaxHeightBaseElementRef={splitLayoutRef}
        />
      </SplitLayout.Body>
    </div>
  );
};

export default SectionStudentMessage;
